import Layout from '@/layouts/BasicLayout/index.vue'
import { ROLE_TYPE } from '@/utils/roleControl'
import type { RouteRecordRaw } from 'vue-router'

const vairety: RouteRecordRaw = {
  path: '/user',
  name: 'User',
  redirect: '/user/roles',
  component: Layout,
  meta: {
    title: '用户管理',
    icon: 'user|svg',
    module: 'User',
    menuOfRoleType: [ROLE_TYPE.ADMIN]
  },
  children: [
    // 角色管理
    {
      path: 'roles',
      name: 'UserRoles',
      component: () => import('@/views/UserRoles/index.vue'),
      meta: {
        title: '角色管理',
        module: 'UserRoles',
        menuOfRoleType: [ROLE_TYPE.ADMIN]
      }
    },
    // 账号管理
    {
      path: 'accounts',
      name: 'UserAccounts',
      component: () => import('@/views/UserAccounts/index.vue'),
      meta: {
        title: '账号管理',
        module: 'UserAccounts',
        menuOfRoleType: [ROLE_TYPE.ADMIN]
      }
    }
  ]
}

export default vairety
